export default __webpack_public_path__ + "static/media/group-propay-icon.3bb50442.svg";